import apiClient from '../apiClient';
import { POST_TRANSPORTATION_URL } from '../apiUrl';

const postTransportationApi = data => {
  return apiClient.post(POST_TRANSPORTATION_URL, data);
};

export default postTransportationApi;
